<template>
  <section class="text" :id="content.name">
    <h2 v-if="content.headline">{{content.headline}}</h2>
    <img v-if="content.image" :src="content.image.src" :alt="content.image.alt">
    <p v-if="content.text" v-html="content.text"></p>
  </section>
</template>

<script>
export default {
  name: 'SimpleText',
  props: {
    content: {
      type: Object,
      default() {
        return {
          headline: '',
          image: null,
          text: ''
        }
      }
    }
  }
}
</script>

<style>

</style>
